(function () {
  const root = document.querySelector(".shared-prayer-landing");
  if (!root) return;

  const unitPrice = 99.99;
  const unitPriceCents = 9999;
  const unitDiscountCents = Math.floor(unitPriceCents * 0.1);
  let quantity = 1;
  let cartRugQuantity = 0;
  let cartTotalCents = 0;

  const money = (value) => `$${value.toFixed(2)}`;
  const selectedTotal = () => {
    const subtotal = unitPrice * quantity;
    const discount = quantity >= 2 ? (unitDiscountCents * quantity) / 100 : 0;
    return { subtotal, discount, total: subtotal - discount };
  };

  const quantityOutput = root.querySelector("#quantity");
  const nativeQuantityInput = root.querySelector("[data-native-quantity]");
  const totalBox = root.querySelector(".selected-total");
  const addButton = root.querySelector(".button--purchase");
  const heroAddButton = root.querySelector("[data-hero-add-to-cart]");
  const mobileAddButton = root.querySelector("[data-mobile-add-to-cart]");
  const mobilePurchaseBar = root.querySelector(".mobile-purchase-bar");
  const productTarget = root.querySelector("#product");
  const purchaseTarget = root.querySelector("#order");
  const variantId = root.getAttribute("data-variant-id");
  const cartConfirmation = root.querySelector("[data-cart-confirmation]");
  const cartConfirmationQuantity = root.querySelector("[data-cart-confirmation-quantity]");
  const cartConfirmationTotal = root.querySelector("[data-cart-confirmation-total]");
  const cartConfirmationStatus = root.querySelector("[data-cart-confirmation-status]");
  const cartConfirmationVolume = root.querySelector("[data-cart-confirmation-volume]");
  const cartVolumeLabel = root.dataset.cartVolumeLabel || "Extra savings";
  const cartVolumeHeading = root.dataset.cartVolumeHeading || "Add one more rug — save an extra 10%";
  const cartVolumeDetail = root.dataset.cartVolumeDetail || "The 10% volume discount applies automatically.";
  const oneRugCart = root.dataset.oneRugCart || "1 rug in cart";
  const cartVolumeApplied = root.dataset.cartVolumeApplied || "Applied in cart";

  function syncShopifyPreviewBarOffset() {
    const previewBar = document.querySelector("#PBarNextFrameWrapper");
    const height = previewBar ? Math.ceil(previewBar.getBoundingClientRect().height) : 0;
    root.style.setProperty("--shopify-preview-bar-offset", `${height}px`);
  }

  syncShopifyPreviewBarOffset();
  new MutationObserver(syncShopifyPreviewBarOffset).observe(document.body, { childList: true });
  window.addEventListener("resize", syncShopifyPreviewBarOffset, { passive: true });

  function initializeProductGallery() {
    const gallery = root.querySelector("[data-product-gallery]");
    if (!gallery) return;

    const image = gallery.querySelector(".product-gallery__image");
    const caption = gallery.querySelector("[data-gallery-caption]");
    const counter = gallery.querySelector("[data-gallery-counter]");
    const previous = gallery.querySelector("[data-gallery-previous]");
    const next = gallery.querySelector("[data-gallery-next]");
    const thumbnails = Array.from(gallery.querySelectorAll("[data-gallery-thumbnail]"));
    const stage = gallery.querySelector(".product-gallery__stage");
    if (!image || !thumbnails.length) return;

    let activeIndex = 0;
    let pointerStartX = null;

    function showPhotograph(index, moveFocus = false) {
      activeIndex = (index + thumbnails.length) % thumbnails.length;
      const thumbnail = thumbnails[activeIndex];
      const nextSrc = thumbnail.dataset.src;
      if (!nextSrc) return;

      image.classList.add("product-gallery__image--changing");
      image.srcset = thumbnail.dataset.srcset || "";
      image.sizes = thumbnail.dataset.sizes || "(max-width: 900px) calc(100vw - 48px), min(50vw, 620px)";
      image.src = nextSrc;
      image.alt = thumbnail.dataset.alt || "Sarmali Family Prayer Rug photograph";
      image.width = Number(thumbnail.dataset.width) || image.width;
      image.height = Number(thumbnail.dataset.height) || image.height;

      const revealImage = () => image.classList.remove("product-gallery__image--changing");
      if (image.complete) window.setTimeout(revealImage, 80);
      else image.addEventListener("load", revealImage, { once: true });

      thumbnails.forEach((item, itemIndex) => {
        const selected = itemIndex === activeIndex;
        item.classList.toggle("product-gallery__thumbnail--active", selected);
        item.setAttribute("aria-selected", String(selected));
        item.tabIndex = selected ? 0 : -1;
      });

      if (caption) caption.innerHTML = `<span>${String(activeIndex + 1).padStart(2, "0")}</span> ${thumbnail.dataset.caption || "Product photograph"}`;
      if (counter) counter.textContent = `${activeIndex + 1} / ${thumbnails.length}`;
      if (moveFocus) thumbnail.focus();
    }

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener("click", () => showPhotograph(index));
      thumbnail.addEventListener("keydown", (event) => {
        if (event.key === "ArrowRight") {
          event.preventDefault();
          showPhotograph(index + 1, true);
        } else if (event.key === "ArrowLeft") {
          event.preventDefault();
          showPhotograph(index - 1, true);
        } else if (event.key === "Home") {
          event.preventDefault();
          showPhotograph(0, true);
        } else if (event.key === "End") {
          event.preventDefault();
          showPhotograph(thumbnails.length - 1, true);
        }
      });
    });

    previous?.addEventListener("click", () => showPhotograph(activeIndex - 1));
    next?.addEventListener("click", () => showPhotograph(activeIndex + 1));

    stage?.addEventListener("pointerdown", (event) => {
      if (event.target.closest("button")) return;
      pointerStartX = event.clientX;
    });
    stage?.addEventListener("pointerup", (event) => {
      if (pointerStartX === null || event.target.closest("button")) {
        pointerStartX = null;
        return;
      }
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 45) return;
      showPhotograph(activeIndex + (distance < 0 ? 1 : -1));
    });
    stage?.addEventListener("pointercancel", () => { pointerStartX = null; });

    showPhotograph(0);
  }

  initializeProductGallery();

  function initializeMobilePurchaseBarVisibility() {
    if (!mobilePurchaseBar || !addButton || typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver((entries) => {
      const purchaseButtonVisible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.65);
      mobilePurchaseBar.classList.toggle("mobile-purchase-bar--hidden", purchaseButtonVisible);
    }, { rootMargin: "0px 0px -90px 0px", threshold: [0, 0.65, 1] });
    observer.observe(addButton);
  }

  initializeMobilePurchaseBarVisibility();

  function ensureHeaderCart() {
    const headerInner = root.querySelector(".microsite-header__inner");
    const headerShop = root.querySelector(".header-shop");
    if (!headerInner) return null;

    let actions = headerInner.querySelector(".microsite-header__actions");
    if (!actions) {
      actions = document.createElement("div");
      actions.className = "microsite-header__actions";
      if (headerShop) {
        headerShop.insertAdjacentElement("beforebegin", actions);
        actions.appendChild(headerShop);
      } else {
        headerInner.appendChild(actions);
      }
    }

    let cartLink = actions.querySelector(".microsite-cart");
    if (!cartLink) {
      cartLink = document.createElement("a");
      cartLink.className = "microsite-cart";
      cartLink.href = "/cart?view=sarmali-family-prayer-rug";
      cartLink.setAttribute("aria-label", "Cart, 0 items");
      cartLink.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l1.7 10.1a2 2 0 0 0 2 1.7h7.9a2 2 0 0 0 1.9-1.4L21 7H6.1M9 20h.01M17 20h.01"/></svg><span class="microsite-cart__badge" hidden>0</span>`;
      actions.appendChild(cartLink);
    }
    return cartLink;
  }

  const headerCart = ensureHeaderCart();

  function renderHeaderCart(cart) {
    const count = cart.item_count || 0;
    const rugItem = (cart.items || []).find((item) => String(item.variant_id) === String(variantId));
    cartRugQuantity = rugItem?.quantity || 0;
    cartTotalCents = cart.total_price || 0;
    const badge = headerCart?.querySelector(".microsite-cart__badge");
    if (headerCart) headerCart.setAttribute("aria-label", `Cart, ${count} ${count === 1 ? "item" : "items"}`);
    if (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    }
    const mobileLabel = root.querySelector(".mobile-purchase-bar div span");
    const mobileTotal = root.querySelector(".mobile-purchase-bar div strong");
    if (cartRugQuantity > 0) {
      if (mobileLabel) mobileLabel.textContent = cartRugQuantity === 1 ? cartVolumeHeading : "10% volume discount applied";
      if (mobileTotal) mobileTotal.textContent = cartRugQuantity === 1
        ? `${oneRugCart} · ${money((cart.total_price || 0) / 100)} total`
        : `${cartRugQuantity} rugs · ${money((cart.total_price || 0) / 100)} total`;
    } else {
      if (mobileLabel) mobileLabel.textContent = root.dataset.mobileEmptyLabel || "Free U.S. shipping • Save 10% on 2+";
      if (mobileTotal) mobileTotal.textContent = "$99.99 each";
    }
    renderSelection();
  }

  function renderSelection() {
    const totals = selectedTotal();
    if (quantityOutput) quantityOutput.textContent = String(quantity);
    if (nativeQuantityInput) nativeQuantityInput.value = String(quantity);
    if (totalBox) {
      totalBox.classList.toggle("selected-total--discounted", quantity >= 2);
      if (cartRugQuantity > 0) {
        totalBox.innerHTML = `
          <div class="selected-total__in-cart"><span>In your cart</span><strong>${cartRugQuantity} ${cartRugQuantity === 1 ? "rug" : "rugs"}</strong></div>
          ${cartRugQuantity >= 2
            ? `<div class="selected-total__discount"><span>Automatic 10% volume discount</span><strong>${cartVolumeApplied}</strong></div>`
            : `<button class="selected-total__offer" type="button" data-volume-action="add"><span>${cartVolumeLabel}</span><strong>${cartVolumeHeading}</strong><small>${cartVolumeDetail}</small></button>`}
          <div class="selected-total__final"><span>Cart total</span><strong>${money(cartTotalCents / 100)}</strong></div>`;
      } else {
        totalBox.innerHTML = `
          <div><span>Subtotal</span><strong>${money(totals.subtotal)}</strong></div>
          ${quantity >= 2
            ? `<div class="selected-total__discount"><span>Automatic 10% discount</span><strong>−${money(totals.discount)}</strong></div>`
            : `<button class="selected-total__offer" type="button" data-volume-action="select"><span>${cartVolumeLabel}</span><strong>Buy 2 rugs — save 10%</strong><small>Tap to select two. The discount applies automatically.</small></button>`}
          <div class="selected-total__final"><span>Total</span><strong>${money(totals.total)}</strong></div>`;
      }
    }
    if (addButton) {
      const cartReady = cartRugQuantity > 0;
      const label = cartReady ? "Checkout" : "Add to cart";
      const price = cartReady ? "" : ` — ${money(totals.total)}`;
      addButton.innerHTML = `${label}${price} <span class="arrow arrow--right" aria-hidden="true">→</span>`;
      addButton.closest(".purchase-actions")?.classList.toggle("purchase-actions--cart-ready", cartReady);
      if (heroAddButton) {
        heroAddButton.innerHTML = `${label}${price} <span class="arrow arrow--right" aria-hidden="true">→</span>`;
      }
      if (mobileAddButton) {
        mobileAddButton.textContent = cartReady ? "Checkout" : "Add to cart";
      }
    }
  }

  function setQuantity(next) {
    quantity = Math.max(1, next);
    renderSelection();
  }

  totalBox?.addEventListener("click", (event) => {
    const offer = event.target.closest("[data-volume-action]");
    if (!offer) return;
    if (offer.dataset.volumeAction === "select") {
      setQuantity(2);
      return;
    }
    addSecondRugFromConfirmation();
  });

  function scrollToPurchase() {
    const desktop = window.matchMedia("(min-width: 801px)").matches;
    const target = desktop
      ? productTarget || purchaseTarget
      : purchaseTarget || productTarget;
    if (!target) return;

    const header = root.querySelector(".microsite-header");
    const headerHeight = header?.getBoundingClientRect().height || 0;
    const breathingRoom = desktop ? 20 : 16;
    const top = window.scrollY + target.getBoundingClientRect().top - headerHeight - breathingRoom;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  }

  const quantityButtons = root.querySelectorAll(".quantity-control button");
  if (quantityButtons[0]) quantityButtons[0].addEventListener("click", () => setQuantity(quantity - 1));
  if (quantityButtons[1]) quantityButtons[1].addEventListener("click", () => setQuantity(quantity + 1));

  root.querySelectorAll('a[href="#order"]').forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      scrollToPurchase();
    });
  });

  root.querySelectorAll(".discount-banner, .multi-buy-offer, .gift-discount, .final-discount-link").forEach((button) => {
    button.addEventListener("click", () => {
      setQuantity(Math.max(2, quantity));
      scrollToPurchase();
    });
  });

  const menuToggle = root.querySelector(".menu-toggle");
  const mobileMenu = root.querySelector("#mobile-menu");
  menuToggle?.addEventListener("click", () => {
    const open = mobileMenu?.classList.toggle("mobile-nav--open") ?? false;
    menuToggle.setAttribute("aria-expanded", String(open));
  });
  mobileMenu?.querySelectorAll("a").forEach((link) => link.addEventListener("click", () => {
    mobileMenu.classList.remove("mobile-nav--open");
    menuToggle?.setAttribute("aria-expanded", "false");
  }));

  function openCartConfirmation() {
    if (!cartConfirmation) return;
    document.body.classList.add("cart-confirmation-open");
    if (typeof cartConfirmation.showModal === "function") {
      if (!cartConfirmation.open) cartConfirmation.showModal();
    } else {
      cartConfirmation.setAttribute("open", "");
    }
    window.requestAnimationFrame(() => cartConfirmation.querySelector("[name='checkout']")?.focus());
  }

  function renderCart(cart) {
    renderHeaderCart(cart);
    const rugItem = (cart.items || []).find((item) => String(item.variant_id) === String(variantId));
    const rugQuantity = rugItem?.quantity || cartRugQuantity;
    const rugTotal = rugItem ? rugItem.final_line_price / 100 : unitPrice * rugQuantity;
    if (cartConfirmationQuantity) {
      cartConfirmationQuantity.textContent = `${rugQuantity} ${rugQuantity === 1 ? "rug" : "rugs"} in cart`;
    }
    if (cartConfirmationTotal) cartConfirmationTotal.textContent = money(rugTotal);
    const cartConfirmationSummaryTotal = root.querySelector("[data-cart-confirmation-summary-total]");
    if (cartConfirmationSummaryTotal) cartConfirmationSummaryTotal.textContent = money((cart.total_price || 0) / 100);
    if (cartConfirmationVolume) cartConfirmationVolume.hidden = rugQuantity !== 1;
    if (cartConfirmationStatus) {
      cartConfirmationStatus.hidden = true;
      cartConfirmationStatus.textContent = "";
    }
    openCartConfirmation();
  }

  function showCartError(message) {
    if (!cartConfirmationStatus) return;
    cartConfirmationStatus.textContent = message;
    cartConfirmationStatus.hidden = false;
    openCartConfirmation();
  }

  async function addToShopifyCart() {
    if (!addButton) return;
    if (cartRugQuantity > 0) {
      window.location.assign("/checkout");
      return;
    }
    if (!variantId) {
      showCartError("The product variant is not ready yet.");
      return;
    }

    addButton.setAttribute("disabled", "disabled");
    heroAddButton?.setAttribute("disabled", "disabled");
    mobileAddButton?.setAttribute("disabled", "disabled");
    addButton.textContent = "Adding…";
    if (heroAddButton) heroAddButton.textContent = "Adding…";
    if (mobileAddButton) mobileAddButton.textContent = "Adding…";
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
      });
      if (!response.ok) throw new Error("This product is not available for checkout yet.");
      const cartResponse = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      if (!cartResponse.ok) throw new Error("The cart could not be loaded.");
      renderCart(await cartResponse.json());
    } catch (error) {
      showCartError(error.message || "The item could not be added. Please try again.");
    } finally {
      addButton.removeAttribute("disabled");
      heroAddButton?.removeAttribute("disabled");
      mobileAddButton?.removeAttribute("disabled");
      renderSelection();
    }
  }

  async function addSecondRugFromConfirmation() {
    if (!variantId || cartRugQuantity !== 1) return;
    const orderOffer = totalBox?.querySelector("[data-volume-action='add']");
    cartConfirmationVolume?.setAttribute("disabled", "disabled");
    cartConfirmationVolume?.setAttribute("aria-busy", "true");
    orderOffer?.setAttribute("disabled", "disabled");
    orderOffer?.setAttribute("aria-busy", "true");
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (!response.ok) throw new Error("The second rug could not be added.");
      const cartResponse = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      if (!cartResponse.ok) throw new Error("The cart could not be loaded.");
      renderCart(await cartResponse.json());
    } catch (error) {
      showCartError(error.message || "The second rug could not be added. Please try again.");
    } finally {
      cartConfirmationVolume?.removeAttribute("disabled");
      cartConfirmationVolume?.removeAttribute("aria-busy");
      orderOffer?.removeAttribute("disabled");
      orderOffer?.removeAttribute("aria-busy");
    }
  }

  addButton?.addEventListener("click", addToShopifyCart);
  heroAddButton?.addEventListener("click", addToShopifyCart);
  cartConfirmationVolume?.addEventListener("click", addSecondRugFromConfirmation);
  root.querySelectorAll("[data-cart-confirmation-close]").forEach((button) => {
    button.addEventListener("click", () => cartConfirmation?.close());
  });
  cartConfirmation?.addEventListener("click", (event) => {
    if (event.target === cartConfirmation) cartConfirmation.close();
  });
  cartConfirmation?.addEventListener("close", () => document.body.classList.remove("cart-confirmation-open"));
  mobileAddButton?.addEventListener("click", () => {
    if (cartRugQuantity > 0) {
      window.location.assign("/checkout");
      return;
    }
    addToShopifyCart();
  });
  renderSelection();
  fetch("/cart.js", { headers: { Accept: "application/json" } })
    .then((response) => response.ok ? response.json() : null)
    .then((cart) => cart && renderHeaderCart(cart))
    .catch(() => {});
})();
